import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FnAvtartextComponent} from './fn-avtar-text.component';
export * from './fn-avtar-text.component';
@NgModule({
  declarations: [FnAvtartextComponent],
  imports: [CommonModule],
  exports: [FnAvtartextComponent]
})
export class FnAvtarTextModule {}

